/**
 * Link Button Component
 * Button to open link insertion dialog
 */

import React, { useState } from 'react'
import { EditorView } from '@codemirror/view'
import { LinkIcon } from '@heroicons/react/24/outline'
import clsx from 'clsx'
import LinkDialog from './LinkDialog'

interface LinkButtonProps {
  view: EditorView | null
  theme?: 'light' | 'dark'
}

const LinkButton: React.FC<LinkButtonProps> = ({ view, theme = 'light' }) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false)

  const buttonClass = clsx(
    'p-1.5 rounded transition-colors',
    theme === 'dark'
      ? 'text-gray-300 hover:bg-gray-700 hover:text-white'
      : 'text-gray-800 hover:bg-gray-100 hover:text-gray-900',
    'disabled:opacity-50 disabled:cursor-not-allowed'
  )

  return (
    <>
      <button
        type="button"
        onClick={() => setIsDialogOpen(true)}
        disabled={!view}
        className={buttonClass}
        title="Insert hyperlink - Creates \\href{url}{text} link"
        aria-label="Insert hyperlink"
      >
        <LinkIcon className="w-4 h-4" />
      </button>

      <LinkDialog
        view={view}
        isOpen={isDialogOpen}
        onClose={() => setIsDialogOpen(false)}
        theme={theme}
      />
    </>
  )
}

export default LinkButton

